import { EventQuery } from "@graphqlTypes";
import { replaceStringVar } from "@/core/utils";

export const getLocationLabel = (location: string, labels: GlobalLabels) => {
  const { locationLabels } = labels;
  switch (location) {
    case "indoors":
      return locationLabels?.indoors;
    case "outdoors":
      return locationLabels?.outdoors;
    default:
      const levelNumber = location.split("-")[1];
      return replaceStringVar(locationLabels?.levelNumber, { level: levelNumber });
  }
}

export const getPricingCopy = (labels: GlobalLabels, pricingType?: string, price?: EventQuery['rhEvent']['eventData']['price'], isMembersOnly = false) => {
  const { eventPriceLabels, membersOnly } = labels || {};
  const { priceWithAdmissionFull, members } = eventPriceLabels || {};
  const out: { main: string; sub?: string } = { main: '' };
  if (!pricingType || !price) return null;
  switch (pricingType) {
    case "ticketed":
      if (isMembersOnly) {
        if (!price.membersPrice) {
          return null;
        }
        out.main = `$${price.membersPrice}`;
        out.sub = membersOnly;
      } else {
        if (!price.gaPrice) {
          return null;
        }
        out.main = `$${price.gaPrice}`;
        if (price.priceWithAdmission) {
          out.sub = `$${price.priceWithAdmission} ${priceWithAdmissionFull}`;
        }
        if (price.membersPrice) {
          out.sub = `${out.sub ? `${out.sub}, ` : ''}$${price.membersPrice} ${members}`;
        }
      }
      break;
    case "free":
      out.main = eventPriceLabels?.free;
      break;
    case "free-with-rsvp":
      out.main = eventPriceLabels?.freeWithRsvpFull;
      break;
    case "free-with-admission":
      out.main = eventPriceLabels?.freeWithAdmissionFull;
      break;
    default:
      out.main = pricingType;
      break;
  }
  return out;
}